import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_toggle_sales_rep_brand: { message: "idle" },
};

export const tenant_toggle_sales_rep_brand_Slice = createSlice({
 name: "tenant_toggle_sales_rep_brand",
 initialState,
 reducers: {
  success_tenant_toggle_sales_rep_brand: (state, action) => {
   state.tenant_toggle_sales_rep_brand = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_toggle_sales_rep_brand: (state, action) => {
   state.tenant_toggle_sales_rep_brand = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_toggle_sales_rep_brand: (state) => {
   state.tenant_toggle_sales_rep_brand = { status: app_consts.IDLE };
  },
  loading_tenant_toggle_sales_rep_brand: (state) => {
   state.tenant_toggle_sales_rep_brand = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_toggle_sales_rep_brand, fail_tenant_toggle_sales_rep_brand, reset_tenant_toggle_sales_rep_brand, loading_tenant_toggle_sales_rep_brand } = tenant_toggle_sales_rep_brand_Slice.actions;

export default tenant_toggle_sales_rep_brand_Slice.reducer;